import React from 'react';
import { Breadcrumbs as BreadcrumbsComponent } from '../../../../../product/components/breadcrumbs';
export const Breadcrumbs = ({
  className
}) => {
  return /*#__PURE__*/React.createElement(BreadcrumbsComponent, {
    className: className
  });
};